<h3 class="title-divider-suche">{{ heading | translate }}</h3>
<ng-form>
  <fieldset>
    <cap-form-row column-classes="col-md-4,col-md-4">
      <cap-form-control invalidKey="EingabeMussValideNummerSeinBeispiel" labelKey="NB-Ident">
        <input
          (blur)="onTouched()"
          (ngModelChange)="model && (model.nbIdent = $event)"
          [ngModel]="model && model.nbIdent"
          name="avMutation.nbIdent"
          size="10"
          type="text" />
      </cap-form-control>
    </cap-form-row>
    <cap-form-row column-classes="col-md-4,col-md-4">
      <cap-form-control invalidKey="EingabeMussValideNummerSein" labelKey="Nummer">
        <input
          (blur)="onTouched()"
          (ngModelChange)="model && (model.nummer = $event)"
          [ngModel]="model && model.nummer"
          name="avMutation.nummer"
          size="10"
          type="text" />
      </cap-form-control>
    </cap-form-row>
  </fieldset>
</ng-form>
